import { useState } from "react";
import { format, parse } from "date-fns";
import { CalendarIcon } from "lucide-react";
import { Popover, PopoverTrigger, PopoverContent } from "./ui/popover";
import { Calendar } from "./ui/calendar";
import { Button } from "./ui/button";

/**
 * DatePicker, shadcn Popover + Calendar
 * value: "YYYY-MM-DD" string (or empty)
 * onChange: receives "YYYY-MM-DD" string (or "")
 */
export default function DatePicker({
 value,
 onChange,
 placeholder = "Pick a date",
 testId = "date-picker",
 minDate,
 maxDate,
 disabled,
 className = "",
}) {
 const [open, setOpen] = useState(false);

 const selected = (typeof value === "string" && value.length === 10)
 ? parse(value, "yyyy-MM-dd", new Date())
 : undefined;

 function handleSelect(date) {
 if (!date) { onChange?.(""); setOpen(false); return; }
 onChange?.(format(date, "yyyy-MM-dd"));
 setOpen(false);
 }

 return (
 <Popover open={open} onOpenChange={setOpen}>
 <PopoverTrigger asChild>
 <Button
 type="button"
 variant="outline"
 data-testid={testId}
 className={`!h-12 justify-start font-normal text-left rounded-md w-full bg-paper hover:bg-cream ${value ? "text-ink" : "text-muted_text"} ${className}`}
 >
 <CalendarIcon className="mr-2 h-4 w-4 text-sage-700" strokeWidth={1.75} />
 {value ? format(selected, "MMM d, yyyy") : placeholder}
 </Button>
 </PopoverTrigger>
 <PopoverContent align="start" className="w-auto p-0 bg-paper rounded-2xl border border-[#E8EBE4] shadow-lg">
 <Calendar
 mode="single"
 selected={selected}
 onSelect={handleSelect}
 disabled={disabled || ((d) => (minDate && d < minDate) || (maxDate && d > maxDate))}
 />
 </PopoverContent>
 </Popover>
 );
}
